import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/images/logos/fbt-logo-3-greybg.jpeg" alt="Fast Boat Trailers" className="footer-logo" loading="lazy" />
            <p>
              Your trusted partner for premium boat trailers and marine transport solutions.
              Quality craftsmanship, reliable service, and competitive prices.
            </p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/trailers">Trailers</Link></li>
              <li><Link to="/inventory">Inventory</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>
              313 Edgewater Dr<br/>
              Edgewater, MD 21037<br/>
              Phone: <a href="tel:410-570-9150" style={{color: '#d1d5db', textDecoration: 'none'}}>410-570-9150</a><br/>
              Email: info@fastboattrailers.com
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Fast Boat Trailers. All rights reserved. | Built for marine enthusiasts by marine experts.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;